import useQueryParams from 'hooks/useQueryParams';
import React from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const ItemDetalle = ({ label, value }) => {
  return (
    <React.Fragment>
      <div>
        <h4 className="d-inline">{label} </h4>
        <p className="d-inline font-source-sans-regular" style={{ fontSize: '20px' }}>
          {value}
        </p>
      </div>
    </React.Fragment>
  );
};

const DetallePagoOnlineRealizado = ({ detallePago }) => {
  const { codProducto } = useQueryParams();

  return (
    <div className="col-12 col-lg-11">
      <div className="">
        {PRODUCTOS.SEGUKIDS !== codProducto && <h1 className="text-center text-mex">{detallePago.msgPago}</h1>}
        {PRODUCTOS.SEGUKIDS === codProducto && (
          <div>
            <h1 className="text-center text-mex mb-0">¡Felicidades, el pago se realizó exitosamente!</h1>
            <h1 className="text-center text-mex mt-0 mb-4">Ahora, tus seres queridos están protegidos con AIG.</h1>
          </div>
        )}
        <div className="">
          <ItemDetalle label="Estado del pago:" value={detallePago?.estadoPagoLabel} />

          <ItemDetalle label="Referencia:" value={detallePago?.referencia} />

          <ItemDetalle label="Fecha del pago:" value={detallePago?.fechaPago} />

          <ItemDetalle label="Hora del pago:" value={detallePago?.horaPago} />

          <ItemDetalle label="Número de autorización:" value={detallePago?.nroAutorizacion} />

          <ItemDetalle label="Monto:" value={`$${detallePago.monto}${' '}${detallePago.moneda}`} />
        </div>
      </div>
    </div>
  );
};

export default DetallePagoOnlineRealizado;
